import { render, staticRenderFns } from "./ProductSubscriptionThumb.vue?vue&type=template&id=4b0a3e3d&lang=pug&"
import script from "./ProductSubscriptionThumb.vue?vue&type=script&lang=js&"
export * from "./ProductSubscriptionThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports